module.exports = __webpack_public_path__ + "img/1440.559fd4fe.jpg";